import { QueryKey, QueryClient } from "react-query";

export function resetBMCRPQueries(buildingModelCarbonReductionPlanId: string, queryClient: QueryClient) {
    queryClient.removeQueries({
        predicate: (query) => {
            const key = query.queryKey as QueryKey;
            return key.includes(buildingModelCarbonReductionPlanId);
        },
    });
}
